import { WhatsappLogo, MapPin, PaperPlaneTilt } from "@phosphor-icons/react";
import { card, btnPrimary, waLink, optimizedUrl } from "./shared";
import { InViewVideo } from "@/components/InViewVideo";

export function MediaStrip({ media, onDelete }) {
  if (!media?.length) return null;
  return (
    <div className="flex gap-2 overflow-x-auto pb-1 snap-x">
      {media.map((m) => (
        <div key={m.media_id} className="relative shrink-0 snap-start">
          {m.type === "video" ? (
            <InViewVideo src={optimizedUrl(m.url)} testId={`media-video-${m.media_id}`} className="h-36 w-28 rounded-xl object-cover bg-sky-100" />
          ) : (
            <img src={optimizedUrl(m.url)} alt="" loading="lazy" className="h-36 w-28 rounded-xl object-cover bg-sky-100" />
          )}
          {onDelete && (
            <button data-testid={`media-delete-${m.media_id}`} onClick={() => onDelete(m.media_id)}
              className="absolute top-1 right-1 h-6 w-6 rounded-full bg-white/90 text-red-500 text-xs font-bold">×</button>
          )}
        </div>
      ))}
    </div>
  );
}

export function BusinessCard({ b, onRequest }) {
  return (
    <div className={`${card} p-5 space-y-3`} data-testid={`business-card-${b.business_id}`}>
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-heading text-xl font-black text-sky-950">{b.name}</h3>
          <p className="text-xs text-sky-700 flex items-center gap-1 mt-0.5"><MapPin size={12} weight="fill" /> {b.location}{b.category ? ` · ${b.category}` : ""}</p>
          <p className="text-sm font-bold text-amber-500 mt-1" data-testid={`business-rating-${b.business_id}`}>
            {b.rating_count > 0
              ? <>★ {b.rating_avg.toFixed(1)} <span className="text-sky-700/60 font-medium">({b.rating_count})</span></>
              : <span className="text-sky-700/50 font-medium text-xs">No ratings yet</span>}
          </p>
        </div>
        {b.whatsapp && (
          <a data-testid={`business-whatsapp-${b.business_id}`} href={waLink(b.whatsapp, `Hi ${b.name}, I found you on Tainapp Market.`)}
            target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-1.5 h-9 px-3 rounded-full bg-[#25D366] text-white text-sm font-bold hover:brightness-95 transition-[filter]">
            <WhatsappLogo size={18} weight="fill" /> +{b.whatsapp}
          </a>
        )}
      </div>
      {b.description && <p className="text-sm text-sky-900/80 whitespace-pre-line">{b.description}</p>}
      <MediaStrip media={b.media} />
      {b.recent_reviews?.filter((r) => r.comment).map((r) => (
        <p key={r.review_id} data-testid={`business-review-${r.review_id}`} className="text-xs text-sky-900/80 bg-sky-50 rounded-xl px-3 py-2">
          <b>{r.customer_name}</b> <span className="text-amber-500">{"★".repeat(r.stars)}</span> — {r.comment}
        </p>
      ))}
      <button data-testid={`business-request-${b.business_id}`} className={`${btnPrimary} w-full`} onClick={() => onRequest(b)}>
        <PaperPlaneTilt size={18} weight="bold" /> Request
      </button>
    </div>
  );
}
